<div class="main-container" *ngIf="!isLoading" data-cy="forms-builder-item-container">

  <h5 data-cy="forms-builder-item-title">Configurations</h5>
  <mat-divider data-cy="forms-builder-item-divider"></mat-divider>

  <div class="form-input-container" data-cy="forms-builder-item-name-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-name-field">
      <input matInput placeholder="Item name" [(ngModel)]="item.DFormItemName" data-cy="forms-builder-item-name-input" />
    </mat-form-field>
  </div>

  <div class="form-input-container" data-cy="forms-builder-item-control-type-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-control-type-field">
      <mat-label data-cy="forms-builder-item-control-type-label">Control type</mat-label>
      <mat-select [(ngModel)]="selectedControlTypeId" data-cy="forms-builder-item-control-type-select">
        <mat-option *ngFor="let controlType of cfgFormItemTypeList; let i = index"
                    [value]="controlType.id"
                    data-cy="forms-builder-item-control-type-option-{{i}}">
          <div class="cfg-form-select-button cfg-form-button-name" (click)="selectControlType(controlType)" data-cy="forms-builder-item-control-type-button-{{i}}">
            {{ controlType.name }}
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-input-container" *ngIf="canUseValidValues" data-cy="forms-builder-item-valid-values-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-valid-values-field">
      <mat-label data-cy="forms-builder-item-valid-values-label">Valid Values</mat-label>
      <mat-select [(ngModel)]="selectedValidValueId" data-cy="forms-builder-item-valid-values-select">
        <mat-option *ngFor="let validValue of validValues; let i = index"
                    matTooltip="{{ getValidValuePreview(validValue) }}"
                    [value]="validValue.ValidValueId"
                    data-cy="forms-builder-item-valid-value-option-{{i}}">
          <div class="cfg-form-select-button cfg-form-button-name" (click)="selectValidValue(validValue)" data-cy="forms-builder-item-valid-value-button-{{i}}">
            {{ validValue.ValidValueName }}
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-input-container" *ngIf="canUseDefaultValue && !canSelectDefaultFromValidValue" data-cy="forms-builder-item-default-value-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-default-value-field">
      <input matInput placeholder="Default value" [(ngModel)]="item.DefaultValue" data-cy="forms-builder-item-default-value-input" />
    </mat-form-field>
  </div>

  <div class="form-input-container" *ngIf="canUseDefaultValue && canSelectDefaultFromValidValue && selectedValidValue" data-cy="forms-builder-item-default-select-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-default-select-field">
      <mat-label data-cy="forms-builder-item-default-select-label">Default value</mat-label>
      <mat-select [(ngModel)]="item.DefaultValue" data-cy="forms-builder-item-default-select">
        <mat-option *ngFor="let validValueItem of selectedValidValue.enumValidValueItems; let i = index"
                    [value]="validValueItem.ValidValueItemId"
                    data-cy="forms-builder-item-default-option-{{i}}">
          <div class="cfg-form-select-button cfg-form-button-name" (click)="selectDefaultValue(validValueItem)" data-cy="forms-builder-item-default-button-{{i}}">
            {{ validValueItem.ItemDisplayValue }}
          </div>
        </mat-option>
        <mat-option data-cy="forms-builder-item-default-clear-option">
          <div class="clear-default-value" (click)="removeDefaultValue()" data-cy="forms-builder-item-default-clear-button">
            Clear default value
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-input-container" data-cy="forms-builder-item-label-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-label-field">
      <input matInput placeholder="Label" [(ngModel)]="item.Label" data-cy="forms-builder-item-label-input" />
    </mat-form-field>
  </div>

  <div class="form-input-container" data-cy="forms-builder-item-post-label-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-post-label-field">
      <input matInput placeholder="Post label" [(ngModel)]="item.PostLabel" data-cy="forms-builder-item-post-label-input" />
    </mat-form-field>
  </div>

  <div class="form-input-container" data-cy="forms-builder-item-before-action-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-before-action-field">
      <mat-label data-cy="forms-builder-item-before-action-label">Before display action</mat-label>
      <mat-select [(ngModel)]="selectedBeforeActionId" data-cy="forms-builder-item-before-action-select">
        <mat-option *ngFor="let action of actionList; let i = index"
                    [value]="action.ItemActionId"
                    data-cy="forms-builder-item-before-action-option-{{i}}">
          <div class="cfg-form-select-button cfg-form-button-name" (click)="selectBeforeAction(action)" data-cy="forms-builder-item-before-action-button-{{i}}">
            {{ action.ActionName}}
          </div>
        </mat-option>
        <mat-option data-cy="forms-builder-item-before-action-clear-option">
          <div class="clear-default-value" (click)="removeBeforeAction()" data-cy="forms-builder-item-before-action-clear">
            Clear action
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-input-container" *ngIf="canUseAfterUpdateAction" data-cy="forms-builder-item-after-action-container">
    <mat-form-field class="form-input" data-cy="forms-builder-item-after-action-field">
      <mat-label data-cy="forms-builder-item-after-action-label">After update action</mat-label>
      <mat-select [(ngModel)]="selectedAfterActionId" data-cy="forms-builder-item-after-action-select">
        <mat-option *ngFor="let action of actionList; let i = index"
                    [value]="action.ItemActionId"
                    data-cy="forms-builder-item-after-action-option-{{i}}">
          <div class="cfg-form-select-button cfg-form-button-name" (click)="selectAfterAction(action)" data-cy="forms-builder-item-after-action-button-{{i}}">
            {{ action.ActionName}}
          </div>
        </mat-option>
        <mat-option data-cy="forms-builder-item-after-action-clear-option">
          <div class="clear-default-value" (click)="removeAfterAction()" data-cy="forms-builder-item-after-action-clear">
            Clear action
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-input-container" data-cy="forms-builder-item-alignment-container">

    <mat-form-field class="form-input" data-cy="forms-builder-item-alignment-field">
      <mat-label data-cy="forms-builder-item-alignment-label">Alignment type</mat-label>
      <mat-select [(ngModel)]="selectedAlignmentType" data-cy="forms-builder-item-alignment-select">
        <mat-option *ngFor="let type of cfgItemAlignmentTypeList; let i = index"
                    [value]="type.id"
                    data-cy="forms-builder-item-alignment-option-{{i}}">
          <div class="cfg-form-select-button cfg-form-button-name" (click)="selectAlignmentType(type)" data-cy="forms-builder-item-alignment-button-{{i}}">
            {{ type.name}}
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>

  <div class="form-input-container" data-cy="forms-builder-item-parent-container">

    <mat-form-field class="form-input" data-cy="forms-builder-item-parent-field">
      <mat-label data-cy="forms-builder-item-parent-label">Parent item</mat-label>
      <mat-select [(ngModel)]="selectedParentItemId" data-cy="forms-builder-item-parent-select">
        <mat-option *ngFor="let otherItem of otherItemsInForm; let i = index"
                    [value]="otherItem.DFormItemId"
                    data-cy="forms-builder-item-parent-option-{{i}}">
          <div class="cfg-form-select-button cfg-form-button-name" (click)="selectParentItem(otherItem)" data-cy="forms-builder-item-parent-button-{{i}}">
            {{ otherItem.DFormItemName}}
          </div>
        </mat-option>
        <mat-option data-cy="forms-builder-item-parent-clear-option">
          <div class="clear-default-value" (click)="clearParentItem()" data-cy="forms-builder-item-parent-clear">
            Clear parent item
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>

  <br />

  <h5 data-cy="forms-builder-item-dimensions-title">Dimensions</h5>
  <mat-divider data-cy="forms-builder-item-dimensions-divider"></mat-divider>

  <div class="form-input-container-small" data-cy="forms-builder-item-column-width-container">
    <mat-form-field class="form-input-small" data-cy="forms-builder-item-column-width-field">
      <input matInput placeholder="Column width" type="number" [(ngModel)]="item.ParagraphColumnWidth" data-cy="forms-builder-item-column-width-input" />
    </mat-form-field>
  </div>

  <div class="form-input-container-small" data-cy="forms-builder-item-row-height-container">
    <mat-form-field class="form-input-small" data-cy="forms-builder-item-row-height-field">
      <input matInput placeholder="Row height" type="number" [(ngModel)]="item.ParagraphRowHeight" data-cy="forms-builder-item-row-height-input" />
    </mat-form-field>
  </div>

  <br />

  <h5 data-cy="forms-builder-item-options-title">Options</h5>
  <mat-divider data-cy="forms-builder-item-options-divider"></mat-divider>

  <div class="form-input-container" data-cy="forms-builder-item-has-children-container">
    <mat-checkbox [(ngModel)]="item.HasChildren" data-cy="forms-builder-item-has-children-checkbox">Has children</mat-checkbox>
  </div>

  <div class="form-input-container" data-cy="forms-builder-item-required-container">
    <mat-checkbox [(ngModel)]="item.isRequired" data-cy="forms-builder-item-required-checkbox">Is required</mat-checkbox>
  </div>


  <div class="form-input-container" data-cy="forms-builder-item-read-only-patient-container">
    <mat-checkbox [(ngModel)]="item.isReadOnlyForPatient" data-cy="forms-builder-item-read-only-patient-checkbox">Is Read Only For Patient</mat-checkbox>
  </div>

  <div class="action-container" data-cy="forms-builder-item-action-container">

    <button mat-raised-button color="primary" class="action-button" (click)="save()" data-cy="forms-builder-item-save-button">Ok</button>
    <button mat-raised-button color="warn" class="action-button" (click)="cancel()" data-cy="forms-builder-item-cancel-button">Cancel</button>

    <button mat-button color="warn" class="action-button-delete" matTooltip="Delete item from the form" (click)="delete()" data-cy="forms-builder-item-delete-button"><i class="material-icons">delete</i></button>
    <button mat-raised-button color="primary" class="action-button-delete" (click)="duplicate()" data-cy="forms-builder-item-duplicate-button">Duplicate</button>

  </div>

</div>
<div class="spinner-container" *ngIf="isLoading" data-cy="forms-builder-item-loading">
  <mat-spinner data-cy="forms-builder-item-spinner"></mat-spinner>
</div>
